import { render, staticRenderFns } from "./PlatForm.vue?vue&type=template&id=b433a414&scoped=true&"
import script from "./PlatForm.vue?vue&type=script&lang=js&"
export * from "./PlatForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b433a414",
  null
  
)

export default component.exports